function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pdf-file",
  transform: "translate(-44.806)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5584",
  "data-name": "Path 5584",
  d: "M119.9,298.154c0-.465-.323-.742-.892-.742a1.975,1.975,0,0,0-.472.045v1.492a1.792,1.792,0,0,0,.383.029C119.522,298.978,119.9,298.672,119.9,298.154Z",
  transform: "translate(-69.445 -280.14)",
  fill: "#2d3e50"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5585",
  "data-name": "Path 5585",
  d: "M194.321,297.681a2.355,2.355,0,0,0-.517.045v3.3a2.069,2.069,0,0,0,.4.023,1.566,1.566,0,0,0,1.709-1.768A1.449,1.449,0,0,0,194.321,297.681Z",
  transform: "translate(-140.345 -280.393)",
  fill: "#2d3e50"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5586",
  "data-name": "Path 5586",
  d: "M60.524,0H49.278A2.984,2.984,0,0,0,46.3,2.98V14h-.291a1.2,1.2,0,0,0-1.2,1.2v7.283a1.2,1.2,0,0,0,1.2,1.2H46.3V25.02A2.983,2.983,0,0,0,49.278,28H64.623A2.983,2.983,0,0,0,67.6,25.02V7.053ZM47.956,16.515a9.413,9.413,0,0,1,1.544-.1,2.421,2.421,0,0,1,1.544.4,1.476,1.476,0,0,1,.54,1.169,1.614,1.614,0,0,1-.465,1.2,2.342,2.342,0,0,1-1.641.532,2.958,2.958,0,0,1-.39-.022V21.5H47.956Zm16.666,9.66H49.278a1.156,1.156,0,0,1-1.154-1.155V23.684h14.3a1.2,1.2,0,0,0,1.2-1.2V15.2a1.2,1.2,0,0,0-1.2-1.2h-14.3V2.98a1.156,1.156,0,0,1,1.154-1.153l10.563-.011v3.9a2.067,2.067,0,0,0,2.067,2.067l3.825-.011.043,17.244A1.155,1.155,0,0,1,64.623,26.175Zm-12.31-4.7V16.515a10.286,10.286,0,0,1,1.544-.1,3.252,3.252,0,0,1,2.068.539,2.235,2.235,0,0,1,.854,1.9,2.56,2.56,0,0,1-.839,2.046,3.625,3.625,0,0,1-2.33.652A9.887,9.887,0,0,1,52.313,21.476Zm8.178-2.937v.929H58.677V21.5H57.531V16.448h3.087v.936H58.677v1.154Z",
  fill: "#2d3e50"
}));

var SvgPdfexport = function SvgPdfexport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.796,
    height: 28,
    viewBox: "0 0 22.796 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfexport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PDFEXPORT.817733f1.svg";
export { ForwardRef as ReactComponent };